import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';

import LogoImage from '/public/home/logo2.svg';
import logo3 from '/public/home/logo3.svg';
import useWindowSize from '/utils/useWindowSize';

const useStyles = makeStyles({
    devRoot: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // padding: 6,
    },
});

const Logo = ({ ...props }) => {
    const classes = useStyles();

    const { width } = useWindowSize();

    return (
        <Box className={`${classes.devRoot} ${props.className || ''}`}>
            <div style={{ cursor: 'pointer', marginBottom: props.marginbottom }}>
                <Link legacyBehavior href="/">
                    <Image
                        {...props}
                        src={props.logo === 'white' ? logo3 : LogoImage}
                        width={props.width ? props.width : 60}
                        height={props.height ? props.height : 60}
                        alt="logo image"
                        priority
                        fetchpriority="high"
                    />
                </Link>
            </div>
            <div style={{ cursor: 'pointer', display: 'flex' }}>
                <Link legacyBehavior href="/">
                    <Box>
                        <Typography
                            variant="h6"
                            style={{
                                color: props.textcolor,
                                marginLeft: 10,
                                whiteSpace: 'nowrap',
                                fontSize: 14,
                            }}
                        >
                            Т.ШАГДАРСҮРЭНГИЙН НЭРЭМЖИТ
                        </Typography>
                        <Typography
                            variant="h3"
                            style={{
                                color: props.textcolor,
                                lineHeight: props.text2Height,
                                fontWeight: 'bold',
                                marginLeft: 10,
                                fontSize: 16,
                            }}
                        >
                            АНАГААХ УХААНЫ ХҮРЭЭЛЭН
                        </Typography>
                    </Box>
                </Link>
            </div>
        </Box>
    );
};

// Logo.propTypes = {
//     className: PropTypes.string,
// };

export default Logo;
